const INDEX_WORKER_WATCH_RULE_CONFLICT = /Index Worker still has WatchRules/i;

/** Backend の IW target-reference rejection を、transport wrapper に依存せず識別します。 */
export function isIndexWorkerWatchRuleConflict(error: unknown): boolean {
  if (typeof error === "string") {
    return INDEX_WORKER_WATCH_RULE_CONFLICT.test(error);
  }
  if (error instanceof Error) {
    return INDEX_WORKER_WATCH_RULE_CONFLICT.test(error.message);
  }
  return INDEX_WORKER_WATCH_RULE_CONFLICT.test(String(error ?? ""));
}
